import { useSettingsStore } from '@renderer/stores/settingsStore'
import React from 'react'

const NotFound: React.FC = () => {
  const { setDefaultProjectId } = useSettingsStore()
  return (
    <div className="bg-whiteout flex h-screen items-center justify-center">
      <div className="w-full max-w-lg p-8 bg-white rounded-lg shadow-2xl text-center">
        <h1 className="text-4xl font-bold text-gradient mb-4 py-2">Oops! Page Not Found</h1>
        <p className="text-gray-600 mb-6">
          The page you&apos;re looking for doesn&apos;t exist. It might have been removed or the URL
          is incorrect.
        </p>
        <button
          onClick={() => {
            setDefaultProjectId(undefined)
            window.location.href = '/'
          }}
          className="py-3 px-6 bg-purple-500 text-white font-semibold rounded-lg hover:bg-purple-600 focus:ring-4 focus:ring-purple-300 transition duration-300"
        >
          Back to Projects
        </button>
      </div>
    </div>
  )
}

export default NotFound
